var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-container"},[_c('div',{staticClass:"comment-text text-sm grey-900"},[_vm._v("\n    "+_vm._s(_vm.comment.text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }